import React, { FC } from 'react';

import ConditionRow from './ConditionRow';

type FirstMessageInSessionConditionProps = {
  index: number;
  onDelete: Function;
};

const FirstMessageInSessionCondition: FC<FirstMessageInSessionConditionProps> = ({ index, onDelete }) => {
  return <ConditionRow index={index} onDelete={onDelete} text="Message starts a new contact" />;
};

export default FirstMessageInSessionCondition;
